export const colors = {
  // Primary Colors
  deepBlue: '#002169',
  seaGreen: '#00a99d',
  brightGreen: '#00ffa0',
  // Secondary Colors
  blue: '#3d6cdd',
  lightBlue: '#5599ea',
  flatBlue: '#82b1eb',
  seaGreen2: '#33bab1',
  seaGreen3: '#66cbc4',
  seaGreen4: '#99ddd8',
  seaGreen5: '#cceeeb',
  highlightRed: '#a5005b',
  darkGreen: '#406070',
  white: '#fff',
  gray: '#eeeef2',
  deepGray: '#cbc8ce',
  txtBlack: '#000d0b',
} as const;
